/**
 * Meilisearch Search Entry Point
 * Initializes search preview for the header search modal
 */

import "../types/meilisearch.d";
import { initSearchPreview, clearInitializedInputs } from "../modules/meilisearch-search-ui";
import { initSearchResults } from "../modules/meilisearch-search-results";
import { onDOMReady } from "../lib/dom";

/**
 * Initialize all search previews on the page
 */
function initAllSearchPreviews(force = false): void {
  // Find all search inputs
  const searchInputs = document.querySelectorAll<HTMLInputElement>(
    'input[type="search"][id^="Search-In-Modal"]'
  );

  console.log("[Meilisearch] Found search inputs:", searchInputs.length, force ? "(force)" : "");

  searchInputs.forEach((input) => {
    // Find the form containing this input
    const form = input.closest("form");
    if (!form) {
      console.warn("[Meilisearch] No form found for input:", input.id);
      return;
    }

    console.log("[Meilisearch] Initializing search for:", input.id);
    // Pass the form as context for finding elements
    initSearchPreview(`#${input.id}`, "[data-meili-search-preview]", form, force);
  });
}

onDOMReady(() => {
  // Initialize search results page (replaces Shopify's native search)
  if (
    window.location.pathname.startsWith("/search") &&
    new URLSearchParams(window.location.search).has("q")
  ) {
    initSearchResults();
  }

  // Initialize immediately
  initAllSearchPreviews();

  // Re-initialize when search input receives focus
  // This handles the DetailsModal which uses preventDefault() on toggle
  document.addEventListener(
    "focusin",
    (e) => {
      const target = e.target as HTMLElement;
      if (
        target.matches('input[type="search"][id^="Search-In-Modal"]') &&
        !target.hasAttribute("data-meili-initialized")
      ) {
        console.log("[Meilisearch] Search input focused, initializing:", target.id);
        // Mark as initialized to prevent repeated re-init on each focus
        target.setAttribute("data-meili-initialized", "true");
        // Clear previous initializations and force re-init
        clearInitializedInputs();
        initAllSearchPreviews(true);
      }
    },
    true
  );
});
